import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Checkbox, Col, DatePicker, Flex, Form, FormInstance, InputNumber, Row, Typography } from "antd";
import FormInput from "../../../../form-input/FormInput";
import './index.scss'
import { viLocale as locale } from "../../../../../utils/pickerType";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FormItemDropdown from "../../../../form-dropdown/FormItemDropdown";
import { get } from "lodash";
import { useParams } from 'react-router-dom';
import { getTeacherOfCourse } from '../../../../../service/list-account-teachers/listAccountTeachersApi';


type CreateClassProps = {
  form: FormInstance,
  isEdit: boolean,
  dataOptions?: any,
  dataDetail: any,
}

const validations = {
  name: {
    required: true,
    message: 'Vui lòng nhập tên lớp'
  },
  startTime: {
    required: true,
    message: "Vui lòng chọn giờ ghi danh"
  },
  startOpenTime: {
    required: true,
    message: "Vui lòng chọn giờ khai giảng"
  },
  form: {
    required: true,
    message: "Vui lòng chọn hình thức ghi danh"
  }
}


const optionTime = [
  {
    id: 10,
    name: "Ngày",
  },
  {
    id: 20,
    name: "Tuần",
  },
  {
    id: 30,
    name: "Tháng"
  }
];

const optionsTeacher = [
  {
    id: 1,
    name: "Giảng Viên 1"
  },
  {
    id: 2,
    name: "Giảng Viên 2"
  },
  {
    id: 3,
    name: "Giảng Viên 3"
  }
]

const CreateClass = ({ form, dataOptions, isEdit, dataDetail }: CreateClassProps) => {
  const { t } = useTranslation();
  const [selectStartedDate, setStartedDate] = useState(get(dataDetail, 'enrolledDate', ''))
  const [selectEndDate, setSelectEndDate] = useState()
  const [selectStartedTime, setStartedTime] = useState(dayjs(get(dataDetail, 'enrolledDate', '')))
  const [selectEndTime, setEndTime] = useState(dayjs(get(dataDetail, 'enrolledDate', '')))
  const [dataTeachers, setDataTeachers] = useState([])
  dayjs.extend(customParseFormat);
  const { id } = useParams()

  const handleChangeStartedDate = (date: any) => {
    setStartedDate(date)
  }

  const handleChangeStartedTime = (time: any) => {
    setStartedTime(time)
  }

  const handleChangeEndedTime = (time: any) => {
    setEndTime(time)
  }

  const handleChangeEndedDate = (date: any) => {

    setSelectEndDate(date)
  }
  const disabledHours = () => {
    if (!selectStartedDate) return []
    // If no date selected, all hours are available
    const currentDate = dayjs();
    const selectedDay = dayjs(selectStartedDate);
    if (selectedDay.isSame(currentDate, 'day')) {
      // If selected date is today, disable past hours
      // @ts-ignore
      const hour = [...Array(currentDate.hour()).keys()];
      return hour;
    }
    return []
  };

  const disabledMinutes = () => {
    if (!selectStartedDate) return []
    const currentDate = dayjs();
    const selectedDay = dayjs(selectStartedDate);
    if (selectedDay.isSame(currentDate, 'day')) {
      // If selected date is today, disable past minutes
      // @ts-ignore
      return [...Array(currentDate.minute()).keys()];
    }
    return []
  }

  const disabledHoursEndDate = () => {
    if (!selectEndDate) return []
    // If no date selected, all hours are available
    const currentDate = dayjs();
    const selectedDay = dayjs(selectEndDate);
    if (selectedDay.isSame(currentDate, 'day')) {
      // If selected date is today, disable past hours
      // @ts-ignore
      return [...Array(currentDate.hour()).keys()];
    }
    return []
  };

  const disabledMinutesEndDate = () => {
    if (!selectEndDate) return []
    const currentDate = dayjs();
    const selectedDay = dayjs(selectEndDate);
    if (selectedDay.isSame(currentDate, 'day')) {
      // If selected date is today, disable past minutes
      // @ts-ignore
      return [...Array(currentDate.minute()).keys()];
    }
    return []
  }

  const disabledDays = (currentDate: any) => {
    if (!selectStartedDate) return currentDate && currentDate.isBefore(dayjs().subtract(1, "day"))
    if (selectStartedDate) {
      return currentDate && currentDate.isBefore(dayjs(selectStartedDate))
    }
  }

  useEffect(() => {
    const fetchTeacherOfCourse = async () => {
      const res = await getTeacherOfCourse(id)
      setDataTeachers(res?.data.data.map((it: any) => {
        return {
          name: it.label,
          id: it.value
        }
      }
      ))

    }
    fetchTeacherOfCourse()
  }, [])
  const currentDate = dayjs()

  let checkDisabledField = !currentDate.isBetween(dataDetail.enrolledDate, dataDetail.closedDate, null, '[]')


  return (
    <>
      <Form
        form={form}
        name="createEnrolledClass"
        className="create-enrolled--class"
      >
        <Typography.Title level={5}>{t("Thông tin chung", "Thông tin chung")}</Typography.Title>
        <Row gutter={16}>
          <Col className="col-table-create" span={24}>
            <Form.Item
              name="name"
              rules={[validations.name]}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              labelAlign="left"
              label={t("Tên lớp", "Tên lớp")}
            >
              <FormInput disabled={isEdit && checkDisabledField} placeholder={t("Nhập tên lớp", "Nhập tên lớp")} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={24}>
            <Row>
              <Col>
                <Form.Item
                  name="form"
                  rules={[validations.form]}
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 18 }}
                  labelAlign="left"
                  label={t("Hình thức", "Hình thức")}
                >
                  <Checkbox.Group

                  >
                    <Flex gap="small" align="baseline">
                      <Checkbox value={10} disabled={isEdit && checkDisabledField} />
                      <Flex vertical={true}>
                        <span className="title-checkbox">
                          {t("Trực tuyến", "Trực tuyến")}
                        </span>
                        <span className="sub-title">
                          {t("Người học tham gia đánh giá trên nền tảng", "Người học tham gia đánh giá trên nền tảng")} {process.env.REACT_APP_PROJECT_NAME || ""}
                        </span>
                      </Flex>
                    </Flex>
                    <Flex gap="small" align="baseline">
                      <Checkbox value={20} disabled={isEdit && checkDisabledField} />
                      <Flex vertical={true}>
                        <span className="title-checkbox">
                          {t("Trực tiếp", "Trực tiếp")}
                        </span>
                        <span className="sub-title">
                          {t("Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo", "Người học tham gia đánh giá trực tiếp tại Cơ sở đào tạo")}
                        </span>
                      </Flex>
                    </Flex>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col className="col-table-create" span={12}>
            <Form.Item
              name="numberStudent"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 9 }}
              labelAlign="left"
              label={t("Số lượng học viên tối đa", "Số lượng học viên tối đa")}
            >
              <InputNumber min={0} max={100} disabled={isEdit && checkDisabledField} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={12}>
            <Form.Item
              name="numberOfSession"
              labelCol={{ span: 15 }}
              wrapperCol={{ span: 9 }}
              labelAlign="left"
              label={t("Số buổi", "Số buổi")}
            >
              <InputNumber min={0} disabled={isEdit && checkDisabledField} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={24}>
            <Form.Item
              name="instructorTeachers"
              label={t("Giảng viên", "Giảng viên")}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              labelAlign="left"
            >
              <FormItemDropdown options={dataTeachers}
                modeDropdown="multiple"
                disabled={isEdit && checkDisabledField}
                placeholder={t("Chọn giảng viên", "Chọn giảng viên")} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={10}>
            <Form.Item
              name="expectedTime"
              label={t("Nỗ lực mong chờ", "Nỗ lực mong chờ")}
              labelCol={{ span: 15 }}
              wrapperCol={{ span: 9 }} labelAlign="left"
            >
              <InputNumber min={0} disabled={isEdit && checkDisabledField} />
            </Form.Item>
          </Col>
          <Col className="col-table-create" span={4}>
            <Form.Item name="expectedTimeType">
              <FormItemDropdown options={optionTime} disabled={isEdit && checkDisabledField} />
            </Form.Item>
          </Col>
        </Row>
        <Typography.Title level={5}>{t("Thời gian ghi danh", "Thời gian ghi danh")}</Typography.Title>
        <Row className="form-time--wrapper" gutter={16}>
          <Col span={6}>
            <label htmlFor="enrolledDate" className="label-required"
            >{t("Ngày mở ghi danh:", "Ngày mở ghi danh:")}
            </label>
          </Col>
          <Col span={18}>
            <Row gutter={16}>
              <Col className="col-table-create" span={16}>
                <Form.Item name="enrolledDate"
                  className="item-time"
                  getValueProps={(i) => ({ value: i ? dayjs(i) : "" })}
                  dependencies={["closedDate"]}
                  rules={[{
                    required: true,
                    message: t("Vui lòng chọn mở ghi danh", "Vui lòng chọn mở ghi danh")
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const futureDate = getFieldValue('closedDate')
                      if (dayjs(value).isAfter(futureDate)) {
                        return Promise.reject(new Error("Ngày mở ghi danh không được sau ngày đóng ghi danh"))
                      }
                      return Promise.resolve()
                    }
                  })
                  ]}
                >
                  <DatePicker format="DD/MM/YYYY"
                    disabledDate={(current) => current.isBefore(dayjs().subtract(1, "day"))} locale={locale}
                    disabled={isEdit && checkDisabledField}
                    onChange={handleChangeStartedDate} />
                </Form.Item>
              </Col>
              <Col className="col-table-create" span={8}>
                <Form.Item
                  name="enrolledTime"
                  className="item-time"
                  rules={[validations.startTime]}
                >
                  <DatePicker.TimePicker disabled={isEdit && checkDisabledField}
                    locale={locale} disabledHours={disabledHours} disabledMinutes={disabledMinutes}
                    value={selectStartedDate && dayjs(selectStartedDate).set('hour', 8).set('minute', 0).toDate()}
                    onChange={handleChangeStartedTime}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <label className="label">{t("Ngày đóng ghi danh:", "Ngày đóng ghi danh:")}
            </label>
          </Col>
          <Col span={18}>
            <Row gutter={16}>
              <Col className="col-table-create" span={16}>
                <Form.Item name="closedDate"
                  className="item-time"
                >
                  <DatePicker format="DD/MM/YYYY"
                    disabledDate={(current) => disabledDays(current)}
                    onChange={handleChangeEndedDate}
                    locale={locale} disabled={isEdit && checkDisabledField} />
                </Form.Item>
              </Col>
              <Col className="col-table-create" span={8}>
                <Form.Item
                  className="item-time"
                  name="closedTime"
                >
                  <DatePicker.TimePicker locale={locale}
                    disabledHours={disabledHoursEndDate}
                    disabledMinutes={disabledMinutesEndDate}
                    onChange={handleChangeEndedTime}
                    disabled={isEdit && checkDisabledField}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

        </Row>

        <Typography.Title level={5}>{t("Thời gian khai giảng", "Thời gian khai giảng")}</Typography.Title>
        <Row className="form-time--wrapper" gutter={16}>
          <Col span={6}>
            <label className="label-required" htmlFor="openingDate">{t("Ngày khai giảng:", "Ngày khai giảng:")}</label>
          </Col>
          <Col span={18}>
            <Row gutter={16}>
              <Col className="col-table-create" span={16}>
                <Form.Item name="openingDate"
                  className="item-time"
                  dependencies={["closingDate"]}
                  getValueProps={(i) => ({ value: i ? dayjs(i) : "" })}
                  rules={[{
                    required: true,
                    message: t("Vui lòng chọn ngày khai giảng", "Vui lòng chọn ngày khai giảng")
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const futureDate = getFieldValue('closingDate')
                      if (!futureDate) {
                        return Promise.resolve();
                      }
                      if (dayjs(value).isAfter(futureDate)) {
                        return Promise.reject(new Error("Ngày khai giảng không được sau ngày kết thúc"))
                      }
                      return Promise.resolve()
                    }
                  })
                  ]}
                >
                  <DatePicker format="DD/MM/YYYY" locale={locale} disabledDate={disabledDays} />
                </Form.Item>
              </Col>
              <Col className="col-table-create" span={8}>
                <Form.Item
                  name="openingTime"
                  className="item-time"
                  rules={[validations.startOpenTime]}

                >
                  <DatePicker.TimePicker locale={locale}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <label className="label">{t("Ngày kết thúc dự kiến:", "Ngày kết thúc dự kiến:")}
            </label>
          </Col>
          <Col span={18}>
            <Row gutter={16}>
              <Col className="col-table-create" span={16}>
                <Form.Item name="closingDate"
                  className="item-time"
                >
                  <DatePicker format="DD/MM/YYYY" locale={locale} disabledDate={disabledDays} />
                </Form.Item>
              </Col>
              <Col span={8} className="col-table-create">
                <Form.Item
                  name="closingTime"
                  className="item-time"
                >
                  <DatePicker.TimePicker
                    locale={locale}
                    disabledHours={disabledHoursEndDate}
                    disabledMinutes={disabledMinutesEndDate}

                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default CreateClass;
